import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { FluidsInfusionAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface FluidsInfusionActionFormGroup {
	rate: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-fluids-infusion-action-controls',
    templateUrl: './fluids-infusion-action-controls.component.html',
    styleUrls: ['../../../common.scss', './fluids-infusion-action-controls.component.scss'],
    imports: [ReactiveFormsModule, UnitQuantityControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsInfusionActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: FluidsInfusionAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as FluidsInfusionAction;
	}

	@Input() form!: FormGroup<FluidsInfusionActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('rate', this.formBuilder.control(this.action?.rate ?? null));
	}
}